module.exports = __webpack_public_path__ + "static/05-6c7ec15e9ddfe636dbd8a07070266ef5.jpg";